module.exports = __webpack_public_path__ + "static/media/BOO-FTM.f28e2fd4.png";